import React from 'react';
import TextField from '../../inputs/text-field/TextField';
import DropDown from '../../inputs/dropdown/Dropdown';
import TextArea from '../../inputs/text-area/TextArea';
import styles from './CompanyCalculator.module.scss';
import { useTranslation } from 'react-i18next';

const CompanyCalculatorForm = () => {
  const countries = [
    { value: 'USA', label: 'USA' },
    { value: 'Pakistan', label: 'Pakistan' },
  ];

  const cityTypes = [
    { value: 'urban', label: 'Urban' },
    { value: 'rural', label: 'Rural' },
  ];

  const tripTypes = [
    { value: 'flight', label: 'Flight' },
    { value: 'train', label: 'Train' },
    { value: 'car', label: 'Car' },
  ];

  const { t } = useTranslation();
  return (
    <form className={styles.companyCalculatorForm}>
      {/* 1. Electricity Consumption */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.companyCalculatorForm.sectionOneHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.companyCalculatorForm.sectionOneParagraph')}</p>
        <div className={styles.inputGroup}>
          <div className={styles.formGroup}>
            <TextField
              label={t('calculatorView.companyCalculatorForm.electricityLabel')}
              name='electricity'
              type='number'
              placeholder={t('calculatorView.companyCalculatorForm.elecricityFieldPlaceHolder')}
            />
          </div>
          <div className={styles.formGroup}>
            <DropDown
              label={t('calculatorView.companyCalculatorForm.countryLabel')}
              name='country'
              option={countries}
            />
          </div>
        </div>
      </div>

      {/* 2. Employees Commuting */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.companyCalculatorForm.sectionTwoHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.companyCalculatorForm.sectionTwoParagraph')}</p>
        <div className={styles.inputGroup}>
          <div className={styles.formGroup}>
            <TextField
              label={t('calculatorView.companyCalculatorForm.employeeLabel')}
              name='employees'
              type='number'
              placeholder={t('calculatorView.companyCalculatorForm.cityPlaceHolder')}
            />
          </div>
          <div className={styles.formGroup}>
            <DropDown label={t('calculatorView.companyCalculatorForm.cityLabel')} name='cityType' option={cityTypes} />
          </div>
        </div>
      </div>

      {/* 3. Business Trips */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.companyCalculatorForm.sectionThreeHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.companyCalculatorForm.sectionThreeParagraph')}</p>
        <div className={styles.inputGroup}>
          <div className={styles.formGroup}>
            <DropDown label={t('calculatorView.companyCalculatorForm.tripLabel')} name='tripType' option={tripTypes} />
          </div>
          <div className={styles.formGroup}>
            <TextField
              label={t('calculatorView.companyCalculatorForm.amountLabel')}
              name='tripAmount'
              type='number'
              placeholder={t('calculatorView.companyCalculatorForm.amountPlaceHolder')}
            />
          </div>
        </div>
      </div>

      {/* 4. Other Activities */}
      <div className={styles.section}>
        <h3 className={styles.sectionTitle}>{t('calculatorView.companyCalculatorForm.sectionFourHeading')}</h3>
        <p className={styles.sectionDescription}>{t('calculatorView.companyCalculatorForm.sectionfourParagraph')}</p>
        <div className={styles.inputGroup}>
          <div className={styles.formGroup}>
            <TextArea
              label={t('calculatorView.companyCalculatorForm.label')}
              name='concept'
              placeholder={t('calculatorView.companyCalculatorForm.placeHolder')}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default CompanyCalculatorForm;
